import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import RegisterStudent from '@/pages/RegisterStudent'
import RegisterTeacher from '@/pages/RegisterTeacher'
import MyLibrary from '@/pages/MyLibrary'
import Palette from '@/pages/Palette'
import AssetLibrary from '@/pages/AssetLibrary'
import StatsViewer from '@/pages/StatsViewer'
import OptimizationStats from '@/pages/OptimizeStats'
import MyClasses from '@/pages/MyClasses'
import Class from '@/pages/Class'
import Student from '@/pages/Student'
import Assessment from '@/pages/Assessment'
import Library from '@/pages/Library'
import SecretLibrary from '@/pages/SecretLibrary'
import ComunityLibrary from '@/pages/ComunityLibrary'
import AuthCallback from '@/pages/AuthCallback'
import Result from '@/pages/Result'
import Analytics from '@/pages/Analytics'
import Tours from '@/pages/Tours'
import Page404 from '@/pages/Page404'

import { store } from '../store.js';

const ifNotAuthenticated = (to, from, next) => {
  if (!store.state.loggedIn) {
    next()
    return
  }
  next('/my-library')
};

const ifAuthenticated = (to, from, next) => {
  if (store.state.loggedIn || (localStorage.getItem('jwt') && localStorage.getItem('jwtReset1'))) {
    next();
    return
  } else {
    next('/login');
    store.state.loginRedirect = to.path;
  }
}

const ifAdmin = (to, from, next) => {
  console.log()
  if (store.state.loggedIn || (localStorage.getItem('jwt') && localStorage.getItem('jwtReset1'))) {
    if (store.state.user && store.state.user.role && store.state.user.role.name === "Administrator") {
      next();
    } else {
      next('/my-library');
    }
    return
  } else {
    next('/login');
    store.state.loginRedirect = to.path;
  }
}

ifAdmin
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    // {
    //   path: '/analytics:id',
    //   name: 'analytics',
    //   component: Analytics,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/connect/:provider/callback',
      name: 'authCallback',
      component: AuthCallback,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/connect/:provider/callback',
      name: 'authCallback',
      component: AuthCallback,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/auth/:provider/callback',
      name: 'authCallback',
      component: AuthCallback,
      beforeEnter: ifNotAuthenticated
    },
    // {
    //   path: '/student-register',
    //   name: 'studentRegister',
    //   component: RegisterStudent,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/teacher-register',
    //   name: 'teacherRegister',
    //   component: RegisterTeacher,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/class/:id',
    //   name: 'class',
    //   component: Class,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/library/:name',
    //   name: 'secretLibrary',
    //   component: SecretLibrary,
    //   beforeEnter: ifNotAuthenticated
    // },
    // {
    //   path: '/assessment/:id',
    //   name: 'assessment',
    //   component: Assessment,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/assessment/:class_id/:result_id',
    //   name: 'result',
    //   component: Result,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/class/:id/:student_id',
    //   name: 'student',
    //   component: Student,
    //   beforeEnter: ifAuthenticated
    // },
    {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: ifAuthenticated
    },
    {
      path: '/my-library',
      name: 'myLibrary',
      component: MyLibrary,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/asset-library',
      name: 'assetLibrary',
      component: AssetLibrary,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/palette-editor',
      name: 'paletteEditor',
      component: Palette,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/stats-viewer',
      name: 'statsViewer',
      component: StatsViewer,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/optimization-stats',
      name: 'OptimizationStats',
      component: OptimizationStats,
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/my-classes',
    //   name: 'myClasses',
    //   component: MyClasses,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/library',
    //   name: 'library',
    //   component: Library,
    //   beforeEnter: ifAuthenticated
    // },
    // {
    //   path: '/view-analytics/:id',
    //   name: 'analytics',
    //   component: Analytics,
    // },
    // {
    //   path: '/tours/:id',
    //   name: 'tours',
    //   component: Tours,
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/404',
      name: '404',
      component: Page404
    },
    // Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/404'
		}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js